// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Lav","text":"Lah","siteName":"Lax","tagline":"Laz","btn":"La1"};